import { Reducer } from "redux";
import { CALL_API } from "../helpers/middleware/api";
import createRequestTypes from "../helpers/createRequestTypes";
import { PaginationMeta, HooplaPurchase } from "types";

const FETCH_PURCHASES = createRequestTypes("FETCH_PURCHASES");
export const fetchPurchases = (offset: number) => ({
  [CALL_API]: {
    types: FETCH_PURCHASES,
    endpoint: `/api/public/v3.0/users/purchases?limit=10&offset=${offset}`,
  },
});

export interface PurchaseState {
  fetching: boolean;
  fetched: boolean;
  purchases: HooplaPurchase[];
  error: boolean;
  pagination: PaginationMeta;
}

const initialState: PurchaseState = {
  fetching: false,
  fetched: false,
  purchases: [],
  error: false,
  pagination: {
    total: 0,
    limit: 10,
    offset: 0,
  },
};

const reducer: Reducer<PurchaseState> = (state = initialState, action): PurchaseState => {
  switch (action.type) {
    case FETCH_PURCHASES.REQUEST:
      return {
        ...state,
        fetching: true,
        fetched: false,
        purchases: [],
        error: false,
      };
    case FETCH_PURCHASES.SUCCESS: {
      const purchases = action.response.events.map((eventGroup: any): HooplaPurchase => {
        return {
          event: {
            eventId: eventGroup.event.event.event_id,
            description: eventGroup.event.event.description,
            name: eventGroup.event.event.name,
            start: eventGroup.event.event.start,
            end: eventGroup.event.event.end,
            data: eventGroup.event.event.data,
            images: eventGroup.event.event.images,
            dateFormat: eventGroup.event.date_format
              ? {
                  dateText: eventGroup.event.date_format.date_text,
                  dateType: eventGroup.event.date_format.date_type,
                }
              : null,
            organizationName: eventGroup.organization.name,
          },
          organization: {
            organizationId: eventGroup.organization.organizationId,
            name: eventGroup.organization.name,
            identifier: eventGroup.organization.identifier,
          },
          purchases: eventGroup.purchases.map((purchase: any) => {
            return {
              numberOfRevokedTickets: purchase.number_of_revoked_tickets,
              numberOfTickets: purchase.number_of_tickets,
              purchase: {
                purchaseId: purchase.purchase.purchase_id,
                finalized: purchase.purchase.finalized,
                orderRef: purchase.purchase.order_ref,
                checkoutMethod: purchase.purchase.checkout_method,
              },
              refCode: purchase.ref_code,
              refCodeHash: purchase.ref_code_hash,
            };
          }),
        };
      });

      const pagination = {
        limit: action.response.limit,
        offset: action.response.offset,
        total: action.response.total_count,
      };
      return {
        ...state,
        fetching: false,
        fetched: true,
        purchases,
        pagination,
      };
    }
    case FETCH_PURCHASES.FAILURE:
      return { ...state, fetching: false, fetched: true, error: true };
    default:
      return state;
  }
};

export default reducer;
